// Copyright (c) 2017 Deere & Company

import {
    closePrintRegistrationFormModal,
    printRegistrationForm,
    updatePrintRegistrationFormModal,
    updateRegistrationModals,
    updateStatusChangeModalVisibility
} from './registration-modals';
import {
    deleteProductRegistration,
    readRegistration,
    resetRegistration,
    updateDealerLocation,
    updateOtherUseAmount,
    updateRegistration,
    updateRegistrationPin,
    updateUseAmount
} from './registration';
import {
    readProductDetails,
    resetProductDetails
} from './product-details';
import {
    resetFormValidation,
    updateFormValidation
} from './form-validation';
import {createRegistrationFormCustomer} from './create-customer';
import {handleRegistrationSubmit} from './handle-submit';
import {readCustomerDetails} from '../../../customer/details/action-creators/details';
import {resetCustomerDetails} from '../../../customer/details/action-creators/reset';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import sharedActionCreators from '../../shared/action-creators';
import {updateAmountOfUseModalVisibility} from './amount-of-use-modal-visibility';
import {updateDomainValues} from './registration-domain-values';

export default {
    ...sharedActionCreators,
    closePrintRegistrationFormModal,
    createRegistrationFormCustomer,
    deleteProductRegistration,
    handleRegistrationSubmit,
    printRegistrationForm,
    readCustomerDetails,
    readProductDetails,
    readRegistration,
    resetCustomerDetails,
    resetFormValidation,
    resetLatestPerUnitMeasurements,
    resetProductDetails,
    resetRegistration,
    updateAmountOfUseModalVisibility,
    updateDealerLocation,
    updateDomainValues,
    updateFormValidation,
    updateOtherUseAmount,
    updatePrintRegistrationFormModal,
    updateRegistration,
    updateRegistrationModals,
    updateRegistrationPin,
    updateStatusChangeModalVisibility,
    updateUseAmount
};



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/index.js